import React, { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import SweetAlert from 'sweetalert2';

import { Delete, Show } from '../../../Constant';
import { useNavigate } from 'react-router';
import { postDataWithToken } from '../../../Utils/restUtils';
import { deleteInvoice } from '../../../CommonURL';

const InvoiceActionCell = ({ row, viewForm, refreshInvoice, setLoading }) => {    
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const redirectToView = () => {
        const editFormURL = `${process.env.PUBLIC_URL}/companies/company-list/userProfile/invoice?id=${row.User_id}&order_id=${row.Id}`;
        navigate(editFormURL);
    };
   
    const deleteInvoiceHandler = (invoiceId) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this invoice!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);

                const deleteRes = { order_id: row.Id };
                const response = await postDataWithToken(deleteInvoice, deleteRes);

                if (response?.data?.message === 'success') {
                    SweetAlert.fire('Deleted!', 'Invoice has been deleted.', 'success');
                    refreshInvoice(1); 
                } else {
                    navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
                }

                setLoading(false);
            }
        });
    };
    return (
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
                <i className="fa fa-ellipsis-v"></i>
            </DropdownToggle>
            <DropdownMenu container="body">
                <DropdownItem style={toggleStyle} onClick={() => redirectToView()}>{Show}</DropdownItem>
                {row.Payment_status==="pending" &&    
                <DropdownItem style={toggleStyle} onClick={() => deleteInvoiceHandler()}>{Delete}</DropdownItem>
                }
                {row.comment === 'subscription-cost' &&
                    <DropdownItem style={toggleStyle} onClick={() => viewForm(row)}>Extend Days</DropdownItem>
                }
                {/* <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px', margin: '0' }} onClick={() => deleteCompanyList()}>{Delete}</DropdownItem> */}
            </DropdownMenu>
        </Dropdown >
    );
};

export default InvoiceActionCell;